import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { App as AntApp, Input } from 'antd';
import { AsyncButton, I } from '../components/kit';
import * as authApi from '../api/auth';

// Landing page for the emailed reset link (AGENT_PASSWORD_RESET_URL?token=…).
// Mirrors the admin portal's ResetPasswordPage: token from query string, new
// password + confirm, POST /api/agent/auth/reset-password, then back to login.
export default function ResetPasswordPage() {
  const nav = useNavigate();
  const { message } = AntApp.useApp();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [success, setSuccess] = useState(false);

  const doReset = async () => {
    if (newPw.length < 8) return message.warning('Use at least 8 characters');
    if (newPw !== confirmPw) return message.warning('Passwords do not match');
    await authApi.createAuthResetPassword({ token, new_password: newPw });
    setSuccess(true);
  };

  const header = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', background: 'var(--surface)', borderBottom: '1px solid var(--border)', flex: 'none' }}>
      <div onClick={() => nav('/login', { replace: true })} style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--text)' }}>
        <I.back width={20} height={20} />
      </div>
      <div style={{ fontSize: 15, fontWeight: 600 }}>Set a new password</div>
    </div>
  );

  if (!token || success) {
    return (
      <div className="app-frame">
        {header}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 14, padding: 22, textAlign: 'center' }}>
          <div style={{ fontSize: 16, fontWeight: 600 }}>{success ? 'Password reset' : 'Invalid reset link'}</div>
          <div style={{ fontSize: 13, color: 'var(--muted)', maxWidth: 300 }}>
            {success
              ? 'Your password has been reset. Sign in with your new password.'
              : 'This link is missing its reset token. Request a new one from “Forgot password?” on the sign-in screen.'}
          </div>
          <AsyncButton type="primary" size="large" onClick={() => nav('/login', { replace: true })}>
            Back to sign in
          </AsyncButton>
        </div>
      </div>
    );
  }

  return (
    <div className="app-frame">
      {header}
      <div className="scrx" style={{ flex: 1, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ fontSize: 13, color: 'var(--muted)' }}>Choose a new password for your agent account.</div>
        <Input.Password size="large" value={newPw} onChange={(e) => setNewPw(e.target.value)} placeholder="New password" autoComplete="new-password" />
        <Input.Password size="large" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} onPressEnter={doReset} placeholder="Confirm new password" autoComplete="new-password" />
        <div style={{ fontSize: 11.5, color: 'var(--muted)' }}>Min 8 characters</div>
        <AsyncButton type="primary" size="large" block onClick={doReset} onError={(e) => message.error(e.message)}>
          Reset password
        </AsyncButton>
      </div>
    </div>
  );
}
